import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ListAltIcon from '@mui/icons-material/ListAlt'
import { colours } from './playerStyles'

// Course title (the page's only h1), where the learner is, and how much of
// the course is done.
const PlayerHeader = ({
  title,
  moduleTitle,
  screenNumber,
  totalScreens,
  completedCount,
  outlineOpen,
  onToggleOutline,
}) => {
  const percent = totalScreens ? Math.round((completedCount / totalScreens) * 100) : 0

  return (
    <Box component="header" sx={{ mb: 2 }}>
      <Typography sx={{ fontSize: '0.9375rem', fontWeight: 700, color: colours.muted, mb: 0.5 }}>
        Training
      </Typography>
      <Typography
        component="h1"
        sx={{ fontSize: { xs: '1.5rem', sm: '1.75rem' }, fontWeight: 700, lineHeight: 1.25, color: colours.text }}
      >
        {title}
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Stack direction="row" justifyContent="space-between" flexWrap="wrap" useFlexGap spacing={1} sx={{ mb: 0.75 }}>
          <Typography sx={{ fontSize: '1rem', fontWeight: 700 }}>
            Screen {screenNumber} of {totalScreens}
          </Typography>
          <Typography sx={{ fontSize: '1rem', color: colours.muted }}>{percent}% complete</Typography>
        </Stack>
        <LinearProgress
          variant="determinate"
          value={percent}
          aria-label="Course progress"
          aria-valuetext={`${completedCount} of ${totalScreens} screens completed`}
          sx={{
            height: 10,
            borderRadius: 5,
            bgcolor: '#E2E8F0',
            '& .MuiLinearProgress-bar': { bgcolor: colours.accent, borderRadius: 5 },
          }}
        />
      </Box>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        useFlexGap
        spacing={1}
        sx={{ mt: 1.5 }}
      >
        <Typography sx={{ fontSize: '1.0625rem', color: colours.text }}>
          <Box component="span" sx={{ color: colours.muted }}>
            Module:{' '}
          </Box>
          {moduleTitle}
        </Typography>
        <Button
          variant="outlined"
          startIcon={<ListAltIcon />}
          onClick={onToggleOutline}
          aria-expanded={outlineOpen}
          aria-controls="course-outline"
        >
          {outlineOpen ? 'Hide course outline' : 'Show course outline'}
        </Button>
      </Stack>
    </Box>
  )
}

export default PlayerHeader
